module.exports = __webpack_public_path__ + "img/diag-step-v2.1708672b.svg";